let order = {
    path: "order",
    name: "order",
    redirect: "/order/index",
    component: () => import("@/views/order/index.vue"),
    meta: {
      name: "订单",
    },
    children: [
      {
        path: "index",
        name: "orderlist",
        component: () => import("@/views/order/pages/index.vue"),
        meta: {
          name: "家政订单",
        }
      },
      {
        path: "detail/:id",
        name: "orderdetail",
        component: () => import("@/views/order/pages/detail.vue"),
        meta: {
            name: "订单详情",
        },
    },
    ],
  };

  export default order;
